import { URLS } from '../config/app-config';
/**
 * Helpers for fetching articles and glossary/topic documents
 */

import {trySecureFetchWithHooks} from "../utils/secureFetch";


// TODO: Add offline mode support for articles

/**
 * Fetch Article
 * @param {object} options - Fetch options, including AbortSignal
 * @param {array} id - Article / topic / glossary ID
 * @param {Release} selectedRelease - Documentation release
 * @param {object} options - Fetch options, including AbortSignal
 * @param {AbortSignal} signal - Optional AbortSignal to cancel the request
 * @param {function} setArticle - Function to set the article data
 * @param {function} inc - Function to increment the loading counter
 * @param {function} dec - Function to decrement the loading counter
 * @param {function} setError - Function to set the error message
 */
export const fetchArticleOnline = async ({
                                            id,
                                            selectedRelease,
                                            is_topic = null,
                                            setArticle,
                                            setError,
                                            inc,
                                            dec,
                                            signal,
                                         }) => {

    let searchParams = selectedRelease.toSearchParams();

    if (is_topic !== null) {
        searchParams.set('is_topic', is_topic.toString());
    }

    const article = await trySecureFetchWithHooks(
        `${URLS.apiBase}/article/${id}?${searchParams}`,
        { signal },
        false,
        true,
        {
            onBeforeFetch: () => inc(),
            onAfterFetch: () => dec(),
            onError: (err) => {
                console.error('Online article fetch error:', err);
                setError(err.message);
            }
        }
    ).then(async r => {
        if (r?.ok) return await r?.json();
        return null;
    })

    if (article === null) return;
    setArticle(article);
};

/**
 * Fetch multiple Articles
 * @param {object} options - Fetch options, including AbortSignal
 * @param {array} ids - List of Article / topic / glossary IDs
 * @param {Release} selectedRelease - Documentation release
 * @param {object} options - Fetch options, including AbortSignal
 * @param {AbortSignal} signal - Optional AbortSignal to cancel the request
 * @param {function} setArticles - Function to set the articles data
 * @param {function} inc - Function to increment the loading counter
 * @param {function} dec - Function to decrement the loading counter
 * @param {function} setError - Function to set the error message
 */
export const fetchArticlesBatchOnline = async ({
                                                    ids,
                                                    selectedRelease,
                                                    setArticles,
                                                    inc,
                                                    dec,
                                                    setError,
                                                    signal,
                                                }) => {

    const articles = await trySecureFetchWithHooks(
        `${URLS.apiBase}/articles?${selectedRelease.toSearchParams()}`,
        {
            signal,
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ article_ids: ids })
        },
        false,
        true,
        {
            onBeforeFetch: () => inc(),
            onAfterFetch: () => dec(),
            onError: (err) => {
                console.error('Online batch articles fetch error:', err);
                setError(err.message);
            }
        }
    ).then(async r => {
        if (r?.ok) return (await r.json()).articles;
        return null;
    })

    if (articles === null) return;
    setArticles(articles);
}
